export default {
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  GET_USER_INFO: 'GET_USER_INFO',
  GET_MENU: 'GET_MENU',
  CHANGE_PWD: 'CHANGE_PWD',
  Get_PUBLICKEY: 'Get_PUBLICKEY',
  GET_NESTED_FLOOR_NAV: 'GET_NESTED_FLOOR_NAV',
  // 水位设置
  STATION_WARN_WATER_INFO: 'STATION_WARN_WATER_INFO',
  SAVE_STATION_WARN_WATER_INFO: 'SAVE_STATION_WARN_WATER_INFO',
  // 水位设置河道
  GET_RIVER_LIST_INFO: 'GET_RIVER_LIST_INFO',
  SAVE_RIVER_LIST_INFO: 'SAVE_RIVER_LIST_INFO',
  // 水位时间段设置新增
  BACK_STATION_WARN_WATER_INFO: 'BACK_STATION_WARN_WATER_INFO',
  BATCH_SAVE_STATION_WARN_WATER_INFO: 'BATCH_SAVE_STATION_WARN_WATER_INFO',
  RESET_PWD: 'RESET_PWD',
  SAVE_FLOOR_NAV: 'SAVE_FLOOR_NAV'
}
